import { Button } from "./button.js";
import { Helper } from "../util/helper.js";
import { NotificationHelper } from "../util/notificationHelper.js";
import { Config } from "../config/config.js";
import { HTTPService, JsonResultClass } from "../util/httpManager.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";
export class ImageDocument extends React.Component<ImageDocumentProps, any>{
    private _base64Data: string = null;
    private _uploadInputRef: HTMLElement = null;
    private _uploadRef: kendo.ui.Upload = null;
    private _imageToUpload = null;
    private _uploadEnabled = false;
    private _lastLoadedIsGuid: string = null;
    private _loading = false;

    constructor(props) {
        super(props);
        this._reload();
    }

    private _handleClickClear = () => {
        this._base64Data = null;
        this.props.onChange(this.props.field, null);
    }

    private _reload = () => {
        if (Helper.hasValue(this.props.value) && this.props.value !== "") {
            this._loading = true;
            HTTPService.post("Document/GetImageDocument", { documentguid: this.props.value })
                .then(result => {
                    this._loading = false;
                    if (result.Code === 0) {
                        this._base64Data = result.Data;
                        this._lastLoadedIsGuid = this.props.value;
                        this.setState({});
                    }
                    else if (result.Code > 0) {
                        this._base64Data = null;
                        this._lastLoadedIsGuid = this.props.value;
                        this.setState({});
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }
    }

    private _upload = () => {
        if (this._imageToUpload !== null) {
            const formData = new FormData();
            formData.append("file", this._imageToUpload.rawFile);
            HTTPService.post<JsonResultClass>("Document/UploadImageDocument", formData)
                .then(result => {
                    this._uploadRef.clearAllFiles();

                    if (result.Code === 1) {
                        NotificationHelper.showErrorMessage(result.Message);
                    } else {
                        this.props.onChange(this.props.field, result.Id);
                    }
                });
        }
    }

    componentDidMount() {
        if (!this.props.field.readOnlyImage) {
            let uploadOptions: kendo.ui.UploadOptions = {
                select: (kendoEvent: kendo.ui.UploadSelectEvent) => {
                    const file = kendoEvent.files[0];
                    const validUpload = Helper.hasValue(file)
                        && (file.extension.toLowerCase() === ".jpg" || file.extension.toLowerCase() === ".jpeg" || file.extension.toLowerCase() === ".gif" || file.extension.toLowerCase() === ".png");

                    if (validUpload) {
                        this._uploadEnabled = true;
                        this._imageToUpload = file;
                        this._upload();
                    } else {
                        this._uploadEnabled = false;
                        this._imageToUpload = null;
                        NotificationHelper.showWarningMessage(Config.translations.unsupportedImagefile);
                        kendoEvent.files.pop();
                        kendoEvent.preventDefault();
                    }
                    this.setState({});
                },
                remove: () => {
                    this._uploadEnabled = false;
                    this._imageToUpload = null;
                    this.setState({});
                },
                multiple: false,
                enabled: !this.props.disabled
            };

            this._uploadRef = $(this._uploadInputRef).kendoUpload(uploadOptions).data("kendoUpload");
        }
    }

    componentDidUpdate() {
        if (this._uploadRef !== null) {
            this._uploadRef.enable(!this.props.disabled);

            if (!this._loading && this._lastLoadedIsGuid !== this.props.value) {
                this._reload();
            }
        }
    }


    render() {
        let width = Helper.hasValue(this.props.field.width) ? this.props.field.width : "";
        let height = Helper.hasValue(this.props.field.height) ? this.props.field.height : "";
        const imageProps: any = {
            style: { marginTop: "5px", marginBottom: "5px", maxWidth: "100%" },
            src: this._base64Data,
            width: width,
            height: height
        }
        if (this.props.field.disableDrag) {
            imageProps.onDragStart = (e) => e.preventDefault();
            imageProps.draggable = false;
        }
        return (
            <div style={{ overflowX: "auto", overflowY: "hidden", textAlign: "center" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    {
                        this._base64Data !== null ? <img {...imageProps} /> :
                            <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                                {Config.translations.noImage}
                            </div>
                    }
                    {
                        this.props.field.readOnlyImage ? null
                            : <div style={{ display: "flex", alignItems: "center", marginLeft: "10px", borderRadius: "var(--border-radius)" }}>
                                <Button readOnly={this.props.disabled || this._base64Data === null} handleClick={this._handleClickClear} iconName={"times"} buttonStyle={{ borderRadius: "var(--border-radius)" }} />
                            </div>
                    }
                </div>
                {
                    this.props.field.readOnlyImage ? null
                        :
                        <div>
                            <input type='file' ref={r => this._uploadInputRef = r} />
                        </div>
                }
            </div>
        );
    }
};

export interface ImageDocumentProps extends BaseComponentProps {
    field: ImageDocumentField;
}

export interface ImageDocumentField extends BaseField {
    readOnlyImage?: boolean;
    width?: string;
    height?: string;
    disableDrag?: boolean;
}